import React, { Component } from "react";
import { connect } from "react-redux";

import BlocComponent from "./BlocComponent";

import {
  setBlocStatus,
  setBlocTitle,
  setBlocSubtitle,
  addNewBloc,
  deleteBloc,
  setBlocLabel,
  setBlocUrl
} from "Actions";

class Bloc extends Component {
  render() {
    return <BlocComponent {...this.props} />;
  }
}
// Connected Component
const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch => ({
  setBlocStatus: (indexSetting, order, status) =>
    dispatch(setBlocStatus(indexSetting, order, status)),
  setBlocTitle: (indexSetting, order, lng, value) =>
    dispatch(setBlocTitle(indexSetting, order, lng, value)),
  setBlocSubtitle: (order, lng, value) =>
    dispatch(setBlocSubtitle(order, lng, value)),
  addNewBloc: (order, type) => dispatch(addNewBloc(order, type)),
  deleteBloc: (index, order) => dispatch(deleteBloc(index, order)),
  setBlocLabel: (indexSetting, order, value) =>
    dispatch(setBlocLabel(indexSetting, order, value)),
  setBlocUrl: (indexSetting, order, value) =>
    dispatch(setBlocUrl(indexSetting, order, value))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Bloc);



// WEBPACK FOOTER //
// ./src/components/Settings/ManageLayout/Bloc/index.js